<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Alertes Stock — Ingrédients</h1>
        <p class="page-subtitle" v-if="alerts.length">{{ alerts.length }} ingrédient{{ alerts.length > 1 ? 's' : '' }} en alerte</p>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <v-card flat class="table-card">
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">INGRÉDIENT</th>
              <th class="text-left">UNITÉ</th>
              <th class="text-right">STOCK</th>
              <th class="text-right">SEUIL</th>
              <th class="text-right">ÉCART</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in alerts" :key="r.id">
              <td class="font-weight-medium">{{ r.name }}</td>
              <td>{{ r.unit }}</td>
              <td class="text-right error--text font-weight-bold">{{ fmt(r.stock) }}</td>
              <td class="text-right">{{ fmt(r.stock_alert) }}</td>
              <td class="text-right">{{ fmt(parseFloat(r.stock) - parseFloat(r.stock_alert)) }}</td>
            </tr>
            <tr v-if="alerts.length === 0">
              <td colspan="5" class="text-center text--secondary pa-6">Aucune alerte</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'

export default {
  name: 'IngredientStockAlertView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    items: [{ text: 'Alertes Ingrédients', disabled: true, href: '/ingredient-alerts' }],
    enable: false,
    alerts: [],
  }),
  methods: {
    fmt(v) { var n = parseFloat(v); if (!n && n !== 0) return '0'; return n.toFixed(2) },
    load() {
      var self = this
      this.$axios.get('/reports/ingredients')
        .then(function (r) {
          var result = (r.data && r.data.result) || { items: [], alerts: [] }
          var alertIds = result.alerts || []
          self.alerts = (result.items || []).filter(function (it) { return alertIds.indexOf(it.id) !== -1 })
          self.enable = true
        })
        .catch(function () { self.enable = true })
    },
  },
  mounted() { this.load() },
}
</script>

<style scoped>
.table-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; overflow: hidden; }
.table-card .v-simple-table thead th { font-size: 0.6875rem !important; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: #94a3b8 !important; padding: 8px 16px !important; }
.table-card .v-simple-table tbody td { font-size: 0.8125rem; padding: 10px 16px !important; }
</style>
